import { Fragment } from 'react';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';
import {
  CardMetaRow,
  CardTitleRow,
  HistoryListItem,
  CardAvatarStack,
} from './styles';

/** 실제 카드의 순번 칩 폭 분포를 흉내내 로딩 후 점프를 줄임 */
const CHIP_WIDTHS = [72, 88, 64];

const CHIP_HEIGHT = 22;

const SkeletonCard = () => (
  <HistoryListItem aria-hidden>
    <CardTitleRow>
      <Skeleton
        variant="rect"
        height={20}
        sx={{ flex: '1 0 0', maxWidth: 190 }}
      />
      <Skeleton variant="rect" width={68} height={18} />
    </CardTitleRow>
    <CardMetaRow>
      <CardAvatarStack inlineFlow>
        {CHIP_WIDTHS.map((width) => (
          <Fragment key={width}>
            <Skeleton
              variant="rect"
              width={width}
              height={CHIP_HEIGHT}
              sx={{ borderRadius: '999px', display: 'inline-block' }}
            />{' '}
          </Fragment>
        ))}
      </CardAvatarStack>
      <Skeleton variant="rect" width={120} height={18} />
    </CardMetaRow>
  </HistoryListItem>
);

/** count 는 직전 페이지의 카드 수 — 대기 중 목록 높이를 유지해 점프를 막음 */
const RecentApprovalLineSkeleton = ({ count }: { count: number }) => (
  <>
    {Array.from({ length: count }, (_, idx) => (
      <SkeletonCard key={idx} />
    ))}
  </>
);

export default RecentApprovalLineSkeleton;
